var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.552,
    y: 75.034,
    style: {
      fill: "#464655"
    },
    width: 17.655,
    height: 44.138
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.793,
    y: 75.034,
    style: {
      fill: "#464655"
    },
    width: 17.655,
    height: 44.138
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA6955"
    },
    d: "M467.862,472.276H44.138c-14.626,0-26.483-11.857-26.483-26.483V278.069h476.69v167.724 C494.345,460.419,482.488,472.276,467.862,472.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B5F50"
    },
    d: "M494.345,318.214v-29.693c-21.6,35.998-60.894,60.169-105.931,60.169H123.586 c-45.037,0-84.331-24.171-105.931-60.169v29.693c25.903,29.433,63.733,48.131,105.931,48.131h264.828 C430.612,366.345,468.441,347.647,494.345,318.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M335.448,87.462c-1.987,0-4.009-0.337-5.983-1.047c-20.366-7.341-46.456-11.38-73.465-11.38 s-53.099,4.039-73.465,11.38c-9.155,3.297-19.288-1.457-22.595-10.63c-3.302-9.173,1.452-19.288,10.63-22.595 c24.452-8.81,53.996-13.465,85.431-13.465s60.979,4.655,85.431,13.465c9.176,3.306,13.931,13.422,10.629,22.595 C349.465,82.983,342.681,87.462,335.448,87.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9785F"
    },
    d: "M388.414,348.69H123.586C55.331,348.69,0,293.358,0,225.103v-88.276 c0-14.626,11.857-26.483,26.483-26.483h459.034c14.626,0,26.483,11.857,26.483,26.483v88.276 C512,293.358,456.669,348.69,388.414,348.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC36E"
    },
    d: "M150.069,384h-17.655c-4.875,0-8.828-3.953-8.828-8.828V348.69h35.31v26.483 C158.897,380.047,154.944,384,150.069,384z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD782"
    },
    cx: 141.241,
    cy: 331.034,
    r: 26.483
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC36E"
    },
    d: "M379.586,384h-17.655c-4.875,0-8.828-3.953-8.828-8.828V348.69h35.31v26.483 C388.414,380.047,384.461,384,379.586,384z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD782"
    },
    cx: 370.759,
    cy: 331.034,
    r: 26.483
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.02a5ecf106b02c7f2769942f44ee06d3.svg";
export { ForwardRef as ReactComponent };